#@import I18n
#@import _
#@export Booking.Presenters.Base

class Booking.Presenters.Base

  module: 'booking'

  constructor: (@options, @templateName) ->
    @module ?= @options?.module
    @model = @options?.model
    @parentModel = @options?.parentModel
    @collection = @options?.collection

  localesBasePath: ->
    "modules.#{@module}.#{@templateName}"

  toHash: ->

  merchantCategoryKey: ->
    if @model.isFoodAndDrink()
      'food_and_drink'
    else if @model.isHBW()
      'health_and_beauty'
    else
      'default'

  loadPreviousData: (key) ->
    previousData = @model.getBookingData()?.additionalFields
    previousData?[key] or ''

  getSchedulingNoun: (args = {}) ->
    { plural, capitalized, withDeterminer } = args

    nounDecorator = if plural then 'plural' else if withDeterminer then 'single_with_determiner' else 'single'
    noun = @getI18n().t "js.modules.booking.scheduling_noun.#{@merchantCategoryKey()}.#{nounDecorator}"
    noun = noun.toLowerCase() if not capitalized
    noun

  getI18n: (scope = @localesBasePath()) ->
    return I18n.scoped(scope) if scope?
    I18n

  toHashWithHelpers: ->
    I18n.mixin(@toHash(), @getI18n())

  generateLink: (i18nKey, href) ->
    label = @getI18n().t(i18nKey)
    "<a href='#{href}'>#{label}</a>"

  imageUrl: (assetName) ->
    Booking.imageUrls[assetName] || ''
